export const useAnonymousClientStorage = () => {
   const cookieOptions = { sameSite: 'lax' as const, secure: location.protocol === 'https:', maxAge: 30 * 24 * 60 * 60 };
   const anonymousId = useCookie<string | null>('anonymousId', cookieOptions);
   const anonymousToken = useCookie<string | null>('anonymousToken', cookieOptions);

   const storAnonymous = (newAnonymous: string, ownerToken?: string) => {
      anonymousId.value = newAnonymous;
      anonymousToken.value = ownerToken || null;
   };

   const clearAnonymous = () => {
      anonymousId.value = null;
      anonymousToken.value = null;
   };
   return { storAnonymous, clearAnonymous, anonymousId, anonymousToken };
};
